var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('section', {
    staticClass: "activity-stage"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('aside', [_c('img', {
    attrs: {
      "src": _vm.currentRound.asideImg
    }
  })]), _c('div', {
    staticClass: "steps"
  }, [_c('div', {
    staticClass: "bubble",
    style: _vm.quoteBubbleImage
  }, [_vm.currentRound && _vm.currentRound.steps && _vm.currentRound.steps[0].needType ? _c('blinking-cursor-text', {
    attrs: {
      "text": _vm.currentRound.steps[0].answer,
      "text-step": 0,
      "class-name": _vm.bubbleTextClass
    }
  }) : _vm._e()], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isNextStep,
      expression: "isNextStep"
    }],
    staticClass: "paragraph"
  }, [_c('img', {
    class: {
      isMobile: _vm.isMobile
    },
    attrs: {
      "src": _vm.currentRound.mainImg
    }
  }), _vm.isNextStep ? _c('blinking-cursor-text', {
    attrs: {
      "text": _vm.currentRound.steps[1].answer,
      "text-step": 1
    }
  }) : _vm._e()], 1)])])]), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }